<template>
  <div class="qn-footer__container">
    <action-button
      v-if="isFirstStep"
      class="warning outline-warning px-4"
      :text="$t('btCancel.Text')"
      i="fa fa-times-circle"
      @click="$emit('cancel')"
    />
    <action-button
      v-if="!isFirstStep && !isFinishStep"
      class="warning outline-warning px-4"
      :text="$t('GoBack')"
      i="fa fa-arrow-circle-left"
      @click="$emit('prev')"
    />
    <action-button
      v-if="!isCompleteStep && !isFinishStep"
      class="success px-4"
      :text="$t('btnContinue.Text')"
      iright="fa fa-arrow-alt-circle-right"
      @click="$emit('next')"
    />
    <div
      v-if="isFinishStep"
      class="d-flex justify-content-center align-items-center w-100"
    >
      <action-button
        class="success px-4"
        :text="$t('lblFinish')"
        i="far fa-check-circle"
        @click="$emit('finish')"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
export default {
  name: 'NavigationFooter',
  components: {
    ActionButton,
  },
  props: {
    currentStepId: {
      type: Number,
    },
    completeStepId: {
      type: Number,
    },
    steps: {
      type: Array,
      required: true,
      default: () => [],
    },
    hideFinishButton: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  computed: {
    firstStep() {
      return this.steps[0];
    },
    lastStep() {
      return this.steps[this.steps.length - 1];
    },
    isFirstStep() {
      return this.firstStep?.id == this.currentStepId;
    },
    isCompleteStep() {
      return this.completeStepId
        ? this.currentStepId == this.completeStepId
        : this.currentStepId ==
            this.steps[this.steps.indexOf(this.lastStep) - 1].id;
    },
    isFinishStep() {
      return this.lastStep?.id == this.currentStepId;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/bootstrap/_colors.scss';
.qn-footer {
  &__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid map-get($colors, 'gray-20');
    padding-top: 20px;
  }

  &-action {
    &__start {
      color: white;
      background-color: map-get($colors, 'primary-1');
    }
    &__next {
      color: white;
      background-color: map-get($colors, 'primary-1');
    }
    &__prev {
      color: map-get($colors, 'primary-1');
      border: 1px solid map-get($colors, 'primary-1');
    }
    &__finish {
      color: map-get($colors, 'primary-1');
    }
  }
}

@media (max-width: 991px) {
  .qn-footer {
    &__container {
      button {
        flex-grow: 1;
        margin: 10px;
      }
    }
  }
}
</style>
